module.exports = __webpack_public_path__ + "static/img/cert-default.20e482c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert-default.png
// module id = CWlk
// module chunks = 126